import React from "react";

export default function LiveCallStatus({ testCaseIds, testCases }) {
  return (
    <div style={s.wrap}>
      <style>{`@keyframes pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.4; } }
        @keyframes spin { to { transform: rotate(360deg); } }`}</style>
      {testCaseIds.map((id) => {
        const tc = testCases.find((t) => t.id === id);
        return (
          <div key={id} style={s.card}>
            <span style={s.dot} />
            <span style={s.text}>{tc?.name || id}</span>
            <span style={s.status}>Running</span>
          </div>
        );
      })}
    </div>
  );
}

const s = {
  wrap: {
    display: "flex", gap: 8, flexWrap: "wrap", padding: "12px 32px 0",
  },
  card: {
    display: "inline-flex", alignItems: "center", gap: 8,
    padding: "6px 14px", borderRadius: 8,
    border: "1px solid #fde68a", background: "#fffbeb",
    fontSize: 13,
  },
  dot: {
    width: 6, height: 6, borderRadius: "50%", background: "#f59e0b",
    animation: "pulse 1.5s ease-in-out infinite",
  },
  text: { fontWeight: 500, color: "#92400e" },
  status: { color: "#b45309", fontSize: 12 },
};
